import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectUser, selectAuthLoading, selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { useAuth } from '@/context/AuthContext';

export const RootRedirect: React.FC = () => {
  const user = useAppSelector(selectUser);
  const authLoading = useAppSelector(selectAuthLoading);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { sessionData, sessionIsPending } = useAuth();

  console.log('🏠 RootRedirect - Auth State:', {
    hasSession: !!sessionData?.user,
    reduxIsAuthenticated: isAuthenticated,
    authLoading,
    sessionIsPending,
    userRole: user?.role || localStorage.getItem('userRole') || sessionData?.user?.role
  });

  // Wait for auth state to load
  if (authLoading || sessionIsPending) {
    console.log('⏳ RootRedirect - Auth loading, showing spinner');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  // Check authentication - support both Clerk and traditional
  const isUserAuthenticated = () => {
    if (sessionData?.user) {
      return true;
    }

    return isAuthenticated;
  };

  if (isUserAuthenticated()) {
    // Get user role from Redux or localStorage
    const userRole = user?.role || sessionData?.user?.role || localStorage.getItem('userRole');

    console.log('✅ RootRedirect - User authenticated, role:', userRole);

    // Route based on role - simplified logic
    if (userRole === 'WORKSPACE_AGENT') {
      return <Navigate to="/home/inbox/your-inbox" replace />;
    }

    // Default route for all other users
    return <Navigate to="/home/inbox/all" replace />;
  } else {
    console.log('❌ RootRedirect - User not authenticated, redirecting to sign-in');
    return <Navigate to="/sign-in" replace />;
  }
};
